// extracted by mini-css-extract-plugin
export default {"viewers":"viewers_viewers__JxfZ+","viewerAvatar":"viewers_viewerAvatar__n5DO-","viewerEmail":"viewers_viewerEmail__lhTD3","viewerTime":"viewers_viewerTime__55Wj2"};